import { IRepositoryList } from "../types/repositoryTypes";

interface GvizCell {
  v?: string | number | null;
  f?: string | null;
}

interface GvizCol {
  label?: string;
}

interface GvizRow {
  c: (GvizCell | null)[];
}

interface GvizTable {
  cols: GvizCol[];
  rows: GvizRow[];
}

interface GvizResponse {
  table: GvizTable;
}

function cellToString(cell: GvizCell | null | undefined): string {
  if (cell == null) return "";
  const value = cell.f ?? cell.v;
  return value == null ? "" : String(value);
}

function parseGvizJson(text: string): GvizResponse {
  const json = text.substring(47).slice(0, -2);
  return JSON.parse(json) as GvizResponse;
}

function rowRecordFromGvizRow(
  table: GvizTable,
  rowData: GvizRow
): Record<string, string> {
  const record: Record<string, string> = {};
  table.cols.forEach((col, idx) => {
    if (!col.label) return;
    record[col.label] = cellToString(rowData.c[idx]);
  });
  return record;
}

function mapRecordToRepository(
  row: Record<string, string>,
  index: number
): IRepositoryList {
  const ma_chung_tu_doi_tac = row["Mã chứng từ đối tác"] ?? "";
  const id = ma_chung_tu_doi_tac
    ? `${ma_chung_tu_doi_tac}-${index}`
    : `row-${index}`;

  return {
    id,
    noi_nhan: row["Nơi nhận"] ?? "",
    ma_chung_tu_doi_tac,
    ghi_chu_noi_dung: row["Ghi chú nội dung hàng hóa"] ?? "",
    thoi_gian_tao: row["Thời gian tạo"] ?? "",
    doi_tac_van_chuyen: row["Đối tác vận chuyển"] ?? "",
    so_kien: row["Số kiện"] ?? "",
  };
}

export function parseGvizSheetResponse(text: string): IRepositoryList[] {
  const jsonData = parseGvizJson(text);
  return jsonData.table.rows.map((rowData, index) =>
    mapRecordToRepository(rowRecordFromGvizRow(jsonData.table, rowData), index)
  );
}
